import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { SnackbarService } from '../components/snackbar.service';
import { PopupDeconnectedUserComponent } from '../../../components/popup/popup-deconnected-user/popup-deconnected-user.component';
import { ErrorMessage } from '../../models/error-message';

@Injectable({
  providedIn: 'root'
})
export class AuthentificationService {

  /** Event afin de savoir si la connexion à été checker */
  @Output() isConnectionCheckedChangedEvent: EventEmitter<boolean> = new EventEmitter();

  private connectionChecked: boolean = false;
  
  /** Property afin de savoir si la connexion est checké */
  public readonly isConnectionChecked: boolean = this.connectionChecked;
  
  static URL = environment.urlServer;

  public headers: HttpHeaders = new HttpHeaders({
    'accept': 'text/plain',
    'Content-Type': 'application/json',
    'Authorization': `bearer ${localStorage.getItem('TOKEN')}`
  });

	constructor(private http: HttpClient, private router: Router, public popupDeconnectedUser: MatDialog, private serviceSnackbar: SnackbarService) {}
  
  public validateEmail(Email: string, Password: string) {
    let headers = new HttpHeaders({ 'accept': 'text/plain', 'Content-Type': 'application/json', });
    return this.http.post(`${environment.urlServer}Login`, JSON.stringify(
      {
        email: Email
      }
    ), { headers: headers, observe: 'response' }).pipe(map((response: HttpResponse<any>) => {

      return response;
    }));
  }

  public validateMagicLink(magicLinkId: string) {
    let headers = new HttpHeaders({ 'accept': 'text/plain', 'Content-Type': 'application/json', });
    return this.http.get(`${environment.urlServer}Login/${magicLinkId}/Validate`, { headers: headers, observe: 'response' }).pipe(map((response: HttpResponse<any>) => {

      return response;
    }));
  }

  public validatePinCode(magicLinkId: string,email:string,pinCode:string) {
    let headers = new HttpHeaders({ 'accept': 'text/plain', 'Content-Type': 'application/json', });
    return this.http.post(`${environment.urlServer}Login/${magicLinkId}/ValidatePinCode`,{email:email,userPinCode:pinCode}, { headers: headers, observe: 'response' }).pipe(map((response: HttpResponse<any>) => {

      return response;
    }));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    return of(err);
  }

  public isConnected(): Observable<any> {
    this.headers = new HttpHeaders({
      'accept': 'text/plain',
      'Content-Type': 'application/json',
      'Authorization': `bearer ${localStorage.getItem('TOKEN')}`
    });
    return this.http.get(`${environment.urlServer}Login/IsConnected`, { headers: this.headers, observe: 'response' })
      .pipe(
        tap((resp: HttpResponse<any>) => {
          return resp;
        }),
        catchError((resp: HttpErrorResponse) => {
          let maxWidth = '150vw';
          let minHeight = 'initial';
          let maxHeight = 'initial';
          let width = '100%';
          let height = 'auto';
          // let height = '1300px';
          let panelClass = 'CUSTOM_GENERAL_MAT_DIALOG';

          if (resp.error !== null && resp.error?.data) {
            const dialogRef = this.popupDeconnectedUser.open(PopupDeconnectedUserComponent, {
              width: width,
              height: height,
              maxWidth: maxWidth,
              minHeight: minHeight,
              maxHeight: maxHeight,
              data: {
                size: 4, title: "Vous avez été déconnecté", data: {
                  Nom_Commercial: resp.error.data.CompteClient_Nom_Commercial,
                  Siege_Email: resp.error.data.CompteClient_Siege_Email,
                  Siege_Telephone: resp.error.data.CompteClient_Siege_Telephone,
                  Document_Logo_URL: resp.error.data.CompteClient_Logo_Url
                }
              },
              panelClass: 'CUSTOM_GENERAL_MAT_DIALOG',
              disableClose: true

            });
            dialogRef.afterClosed().subscribe((result: any) => {
              this.router.navigate(['']);
              localStorage.removeItem("TOKEN");
              if (window.location.href.includes("log")) {
                localStorage.setItem("requestedUrl", window.location.href);
              }
            });
          } else {
            if (resp.status == 401) 
              this.serviceSnackbar.displayError(new ErrorMessage().error_api_login_errorSessionExpired);
            
            this.setConnectionChecked(true);
            this.router.navigate(['']);
            localStorage.removeItem("TOKEN");
            if (window.location.href.includes("log")) {
              localStorage.setItem("requestedUrl", window.location.href);
            }
          }
          return (resp.ok, this.handleAuthError(resp));
        })
      );;
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  // /** Setter de la connexion checké */
  public setConnectionChecked(value: boolean) {
    this.connectionChecked = value;
    this.isConnectionCheckedChangedEvent.emit(this.connectionChecked);
  }

  getEvent() {
    return this.isConnectionCheckedChangedEvent;
  }
}
